import {FormEntity} from '../../../content/shared/entities/FormEntity';
import {AbstractEntity} from '../abstract';

/**
 * Holds the url and alt for an image. Tried out object destructuring and private properties here
 * @class
 * @extends AbstractEntity
 */
export class ImageEntity extends AbstractEntity {

  /**
   * Image title
   * @private
   * @type {FormEntity}
   */
  private title: FormEntity;

  /**
   * Alt field
   * @private
   * @type {FormEntity}
   */
  private alt: FormEntity;

  /**
   * Image caption
   * @private
   * @type {FormEntity}
   */
  private caption: FormEntity;

  /**
   * Credits for the image
   * @private
   * @type {FormEntity}
   */
  private credits: FormEntity;

  /**
   * Image keywords
   * @private
   * @type {FormEntity}
   */
  private keywords: FormEntity;

  /**
   * Crop gravity of the image
   * @private
   * @type {FormEntity}
   */
  private cropGravity: FormEntity;

  /**
   * Get the image title
   * @returns {FormEntity}
   */
  getTitle(): FormEntity {
    return this.title;
  }

  /**
   * Set the image title
   * @param {string} title The image title
   * @returns {void}
   */
  setTitle(title): void {
    this.title = new FormEntity(title);
  }

  /**
   * Gets the alt field
   * @returns {FormEntity}
   */
  getAlt(): FormEntity {
    return this.alt;
  }

  /**
   * Sets the alt field
   * @param {string} alt The alt text
   * @returns {void}
   */
  setAlt(alt): void {
    this.alt = new FormEntity(alt);
  }

  /**
   * Gets the caption
   * @returns {FormEntity}
   */
  getCaption(): FormEntity {
    return this.caption;
  }

  /**
   * Sets the caption
   * @param {string} caption The caption text
   * @returns {void}
   */
  setCaption(caption): void {
    this.caption = new FormEntity(caption);
  }

  /**
   * Gets the credits
   * @returns {FormEntity}
   */
  getCredits(): FormEntity {
    return this.credits;
  }

  /**
   * Sets the credits
   * @param {string} credits The credits text
   * @returns {void}
   */
  setCredits(credits): void {
    this.credits = new FormEntity(credits);
  }

  /**
   * Gets the keywords
   * @returns {FormEntity}
   */
  getKeywords(): FormEntity {
    return this.keywords;
  }

  /**
   * Sets the keywords
   * @param {string} keywords The keywords text
   * @returns {void}
   */
  setKeywords(keywords): void {
    this.keywords = new FormEntity(keywords);
  }

  /**
   * Gets the crop gravity
   * @returns {FormEntity}
   */
  getCropGravity(): FormEntity {
    return this.cropGravity;
  }

  /**
   * Sets the crop gravity
   * @param {string} cropGravity The crop gravity field
   * @returns {void}
   */
  setCropGravity(cropGravity): void {
    this.cropGravity = new FormEntity(cropGravity);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/entities/image/image.entity.ts